import { useEffect } from '@wordpress/element';
import ErrorHandler from '../utils/ErrorHandler';

const Content = ( props ) => {
	const { eventRegistration, emitResponse } = props;
	const { onCheckoutFail  } = eventRegistration;

	useEffect( () => {
		const unsubscribe = onCheckoutFail(async (paymentResponse) => {
			const errorMessage = paymentResponse.processingResponse.paymentDetails.errorMessage ?? '';
		  
			let errorHandler = new ErrorHandler(
                'Default message',
                document.querySelector('.woocommerce-notices-wrapper')
            );

            errorHandler.clear();
            errorHandler.message(errorMessage);
        });

		// Unsubscribes when this component is unmounted.
		return () => {
			unsubscribe();
		};
	}, [
		emitResponse.responseTypes.ERROR,
	] );

	return <div>
                {props.children}
            </div>;
};

export default Content;